import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=633a1886&scoped=true"
import script from "./rules.vue?vue&type=script&lang=js"
export * from "./rules.vue?vue&type=script&lang=js"
import style0 from "./rules.vue?vue&type=style&index=0&id=633a1886&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633a1886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633a1886')) {
      api.createRecord('633a1886', component.options)
    } else {
      api.reload('633a1886', component.options)
    }
    module.hot.accept("./rules.vue?vue&type=template&id=633a1886&scoped=true", function () {
      api.rerender('633a1886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/Liveness/rules.vue"
export default component.exports